import React from 'react';
import { formatNumber, formatCurrency } from '../../../helpers';
import './index.scss';
import { getText } from '../../../texts';
import { data } from '../../../data';

interface CityInfoProps {
  activeYear: number;
  city: (typeof data.cities)[0];
}

const CityInfo: React.FC<CityInfoProps> = ({ city, activeYear }) => {
  const stats = city.chart_data.find((city) => city.year === activeYear) || ({} as any);

  return (
    <div className="city-info">
      <h5 className="font-accent">{city.full_name}</h5>
      <p className="city-info-title">
        {getText('info_title_revenue', { year: activeYear, value: formatCurrency(stats.total.revenue) })}
      </p>
      <ul className="city-info-item">
        <li>{getText('info_title_revenue_creative', { value: formatCurrency(stats.creative.revenue) })}</li>
        <li>{getText('info_title_revenue_technical', { value: formatCurrency(stats.technical.revenue) })}</li>
        <li>{getText('info_title_revenue_professional', { value: formatCurrency(stats.professional.revenue) })}</li>
      </ul>
      <p className="city-info-title">
        {getText('info_title_population', { year: activeYear, value: formatNumber(stats.total.population) })}
      </p>
      <ul className="city-info-item">
        <li>{getText('info_title_population_creative', { value: formatNumber(stats.creative.population) })}</li>
        <li>{getText('info_title_population_technical', { value: formatNumber(stats.technical.population) })}</li>
        <li>{getText('info_title_population_professional', { value: formatNumber(stats.professional.population) })}</li>
      </ul>
    </div>
  );
};

export default CityInfo;
